import {Program} from "@/program/interfaces/Program";

/**
 * Determine if a program is a hospital program.
 */
export const isHospitalProgram = (program: Program) => {
    return program.organization.entity_type === "hospital";
};

/**
 * Determine if a program is a laboratory program.
 */
export const isLaboratoryProgram = (program: Program) => {
    return program.organization.entity_type === "laboratory";
};
